import { Route, Routes } from 'react-router-dom';
import { useDesign } from '@app/hooks';
import { CustomNavigate } from '@app/page-components';
import { ListIntents } from '@app/page-components/intent';
import { CreateIntentPage } from './create/page';
import { EditIntentPage } from './edit/page';
import { ImportFromLibraryPage } from './import/page';
import { ImportFromCsvPage } from './import-from-csv/page';
import { ViewIntentPage } from './view/page';

export function IntentManagementLayout() {
  const serialized = useDesign();

  return (
    <>
      <ListIntents serialized={serialized} />
      <Routes>
        <Route path='' />
        <Route path="edit/:id" element={<EditIntentPage />} />
        <Route path="view/:id" element={<ViewIntentPage />} />
        <Route path="create" element={<CreateIntentPage />} />
        <Route path="import" element={<ImportFromLibraryPage />} />
        <Route path="import-from-csv" element={<ImportFromCsvPage />} />
        <Route path='*' element={<CustomNavigate to='' />} />
      </Routes>
    </>
  );
}
